import { Form, Head } from "@inertiajs/react"

import InputError from "@/components/input-error"
import TextLink from "@/components/text-link"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Spinner } from "@/components/ui/spinner"
import AuthLayout from "@/layouts/auth-layout"
import { signInPath, signUpPath } from "@/routes"

export default function Register() {
  return (
    <AuthLayout
      title="Create your broker account"
      description="Sign up to build co-branded Treystar brochures"
    >
      <Head title="Sign up" />
      <Form
        method="post"
        action={signUpPath()}
        encType="multipart/form-data"
        resetOnSuccess={["password"]}
        className="flex flex-col gap-6"
      >
        {({ processing, errors }) => (
          <>
            <div className="grid gap-6">
              <div className="grid grid-cols-2 gap-4">
                <div className="grid gap-2">
                  <Label htmlFor="first_name">First name</Label>
                  <Input
                    id="first_name"
                    name="first_name"
                    required
                    autoFocus
                    tabIndex={1}
                    autoComplete="given-name"
                  />
                  <InputError messages={errors.name} />
                </div>
                <div className="grid gap-2">
                  <Label htmlFor="last_name">Last name</Label>
                  <Input
                    id="last_name"
                    name="last_name"
                    required
                    tabIndex={2}
                    autoComplete="family-name"
                  />
                </div>
              </div>

              <div className="grid gap-2">
                <Label htmlFor="company_name">Brokerage company</Label>
                <Input
                  id="company_name"
                  name="company_name"
                  tabIndex={3}
                  placeholder="e.g. NAI Realty Group"
                />
                <InputError messages={errors.company_name} />
              </div>

              <div className="grid gap-2">
                <Label htmlFor="email">Email address</Label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  required
                  tabIndex={4}
                  autoComplete="email"
                  placeholder="email@example.com"
                />
                <InputError messages={errors.email} />
              </div>

              <div className="grid gap-2">
                <Label htmlFor="phone">Phone</Label>
                <Input
                  id="phone"
                  name="phone"
                  type="tel"
                  tabIndex={5}
                  autoComplete="tel"
                  placeholder="e.g. (555) 123-4567"
                />
                <InputError messages={errors.phone} />
              </div>

              <div className="grid gap-2">
                <Label htmlFor="password">Password</Label>
                <Input
                  id="password"
                  name="password"
                  type="password"
                  required
                  tabIndex={6}
                  autoComplete="new-password"
                  placeholder="At least 8 characters"
                />
                <InputError messages={errors.password} />
              </div>

              <div className="grid gap-2">
                <Label htmlFor="headshot">Headshot</Label>
                <Input
                  id="headshot"
                  name="headshot"
                  type="file"
                  accept="image/*"
                  tabIndex={7}
                />
                <p className="text-muted-foreground text-xs">
                  Used on your co-branded brochures.
                </p>
                <InputError messages={errors.headshot} />
              </div>

              <div className="grid gap-2">
                <Label htmlFor="logo">Company logo</Label>
                <Input
                  id="logo"
                  name="logo"
                  type="file"
                  accept="image/*"
                  tabIndex={8}
                />
                <InputError messages={errors.logo} />
              </div>

              <Button
                type="submit"
                className="mt-2 w-full"
                tabIndex={9}
                disabled={processing}
              >
                {processing && <Spinner />}
                Create account
              </Button>
            </div>

            <div className="text-muted-foreground text-center text-sm">
              Already have an account?{" "}
              <TextLink href={signInPath()} tabIndex={10}>
                Log in
              </TextLink>
            </div>
          </>
        )}
      </Form>
    </AuthLayout>
  )
}
